/* Maison Renée – comportements du thème */
(function () {
  const $ = (q, r = document) => r.querySelector(q);
  const $$ = (q, r = document) => [...r.querySelectorAll(q)];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- argent ---------- */
  const data = JSON.parse(($('#mr-cart-data') || {}).textContent || '{}');
  /* même présentation que les prix affichés par Shopify (modèle tiré de 1 000 000 et 1,23) */
  function money(cents) {
    const big = (data.big || '1 000 000 €').replace(/&nbsp;|&#160;/g, '\u00a0'), dec = (data.dec || '1,23 €').replace(/&nbsp;|&#160;/g, '\u00a0');
    const a = big.indexOf('1'), z = big.lastIndexOf('0');
    const pre = big.slice(0, a), post = big.slice(z + 1), th = big.charAt(a + 1);
    const ds = dec.charAt(dec.indexOf('1') + 1);
    const whole = cents % 100 === 0;
    const int = Math.floor(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, /\d/.test(th) ? '' : th);
    return pre + int + (whole ? '' : ds + String(cents % 100).padStart(2, '0')) + post;
  }

  /* ---------- menu burger ---------- */
  const nav = $('#mr-nav');
  document.addEventListener('click', e => {
    if (e.target.closest('[data-mr-open-nav]')) { nav && nav.classList.add('on'); }
    if (e.target.closest('[data-mr-close-nav]') || e.target.closest('#mr-nav nav a')) { nav && nav.classList.remove('on'); }
  });

  /* choix pays / langue : envoi au changement */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-mr-loc] button[data-k]'); if (!b) return;
    b.form.querySelector(`input[name="${b.dataset.k}"]`).value = b.dataset.v; b.form.submit();
  });
  /* le menu langue / pays se ferme quand on clique ailleurs */
  document.addEventListener('click', e => { $$('.mr-loc[open]').forEach(d => { if (!d.contains(e.target)) d.open = false; }); });

  /* ---------- alignement des titres, descriptifs, prix ---------- */
  function eq() {
    $$('[data-mr-eq]').forEach(g => {
      if (!g.offsetParent) return;
      const cards = [...g.children];
      const sels = g.classList.contains('mr-trio') ? ['.cap h3'] : ['h3', '.s'];
      sels.forEach(sel => cards.forEach(c => { const e = $(sel, c); if (e) e.style.minHeight = ''; }));
      const car = getComputedStyle(g).display === 'flex';
      const rows = {};
      cards.forEach(c => { const k = car ? 0 : c.offsetTop; (rows[k] = rows[k] || []).push(c); });
      Object.values(rows).forEach(row => sels.forEach(sel => {
        const els = row.map(c => $(sel, c)).filter(Boolean);
        const m = Math.max(...els.map(e => e.offsetHeight));
        els.forEach(e => e.style.minHeight = m + 'px');
      }));
    });
  }
  addEventListener('resize', eq); addEventListener('load', eq);
  document.fonts && document.fonts.ready.then(eq);

  /* ---------- points sous les carrousels ---------- */
  $$('.mr-cdots').forEach(d => {
    const g = document.getElementById(d.dataset.for); if (!g) return;
    const n = g.children.length;
    d.innerHTML = '<i class="on"></i>' + '<i></i>'.repeat(Math.max(0, n - 1));
    g.addEventListener('scroll', () => { const k = Math.round(g.scrollLeft / g.clientWidth); $$('i', d).forEach((x, i) => x.classList.toggle('on', i === k)); }, { passive: true });
  });

  /* ---------- engagements qui défilent (téléphone) ---------- */
  $$('[data-mr-why]').forEach(w => {
    const it = [...w.children]; if (it.length < 2) return; let k = 0;
    setInterval(() => { it[k].classList.remove('on'); k = (k + 1) % it.length; it[k].classList.add('on'); }, 3200);
  });

  /* ---------- composez votre costume ---------- */
  $$('[data-mr-suit]').forEach(s => s.addEventListener('click', e => {
    const b = e.target.closest('.mr-fab button'); if (!b) return;
    $$('.mr-fab button', s).forEach(x => x.classList.toggle('on', x === b));
    $$('.mr-fset', s).forEach(x => x.classList.toggle('mr-hidden', x.dataset.f !== b.dataset.f));
    eq();
  }));

  /* ---------- fiche produit ---------- */
  const pdp = $('[data-mr-product]');
  if (pdp) {
    document.body.classList.add('mr-has-mbar');
    const mbar = $('[data-mr-mbar]', pdp); mbar && mbar.classList.add('show');
    const input = $('[data-mr-variant]', pdp);
    const mates = JSON.parse(($('[data-mr-mates]', pdp) || {}).textContent || '{}');
    const addBtn = $('.mr-buy [data-mr-add]', pdp);
    const base = +(addBtn && addBtn.dataset.price || 0);
    const curSize = () => { const b = $('[data-mr-sizes] button.on', pdp); return b ? b.dataset.size : ''; };
    function refresh() {
      let t = base; $$('[data-mr-mate].on', pdp).forEach(b => t += +b.dataset.price);
      const tot = $('[data-mr-total]', pdp); if (tot) tot.textContent = money(t);
      const ms = $('[data-mr-mbar-size]', pdp); if (ms) ms.textContent = curSize() ? ' · ' + curSize() : '';
    }
    pdp.addEventListener('click', e => {
      const sz = e.target.closest('[data-mr-sizes] button');
      if (sz && !sz.classList.contains('soldout')) { $$('[data-mr-sizes] button', pdp).forEach(x => x.classList.toggle('on', x === sz)); input.value = sz.dataset.id; refresh(); }
      const m = e.target.closest('[data-mr-mate]');
      if (m) { m.classList.toggle('on'); m.textContent = m.classList.contains('on') ? data.t.added : data.t.add; refresh(); }
      const a = e.target.closest('[data-mr-add]');
      if (a) {
        const items = [{ id: +input.value, quantity: 1 }];
        $$('[data-mr-mate].on', pdp).forEach(b => {
          const vs = mates[b.dataset.mrMate] || [];
          const v = vs.find(x => x.s === curSize() && x.a) || vs.find(x => x.a);
          if (v) items.push({ id: v.id, quantity: 1 });
          b.classList.remove('on'); b.textContent = data.t.add;
        });
        add(items); refresh();
      }
    });
    refresh();
    /* date de livraison estimée (France) : 4 à 6 jours ouvrés */
    const eta = $('[data-mr-eta]', pdp);
    if (eta) {
      const addBD = (d, n) => { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
      const o = { day: 'numeric', month: 'long' }, lang = document.documentElement.lang || 'fr';
      eta.innerHTML = eta.dataset.tpl.replace('__A__', addBD(new Date(), 4).toLocaleDateString(lang, o)).replace('__B__', addBD(new Date(), 6).toLocaleDateString(lang, o));
    }
  }

  /* ---------- panier ---------- */
  const drawer = $('#mr-drawer');
  const open = () => drawer && drawer.classList.add('on');
  const close = () => drawer && drawer.classList.remove('on');
  async function add(items) {
    const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    if (!r.ok) { const j = await r.json().catch(() => ({})); alertLine(j.description || j.message); }
    await render(); open();
  }
  function alertLine(msg) { const el = $('[data-mr-items]'); if (el && msg) el.insertAdjacentHTML('afterbegin', `<p class="empty" style="color:#a33">${msg}</p>`); }
  function suitOf(h) { return (data.suits || []).find(s => s.some(x => x.h === h)); }
  async function render() {
    if (!drawer) return;
    const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    $$('[data-mr-count]').forEach(x => x.textContent = cart.item_count);
    const sub = cart.items_subtotal_price, S = data.threshold || 30000;
    const ship = $('[data-mr-ship]', drawer);
    if (ship) ship.innerHTML = (sub >= S ? data.t.freeDone : data.t.freeLeft.replace('__X__', money(S - sub))) + `<div class="bar"><i style="width:${Math.min(100, sub / S * 100)}%"></i></div>`;
    $('[data-mr-items]', drawer).innerHTML = cart.items.length ? cart.items.map((x, i) => {
      const opt = x.options_with_values && x.options_with_values.find(o => o.value !== 'Default Title');
      const img = x.image ? x.image + (x.image.includes('?') ? '&' : '?') + 'width=200' : '';
      return `<div class="it"><a class="th" href="${x.url}">${img ? `<img src="${img}" alt="">` : ''}</a><div><a href="${x.url}"><b>${x.product_title}</b></a><span>${opt ? data.t.size + ' ' + opt.value : data.t.oneSize}${x.quantity > 1 ? ' · ×' + x.quantity : ''}</span><button class="rm" data-mr-rm="${i + 1}">${data.t.remove}</button></div><div>${money(x.final_line_price)}</div></div>`;
    }).join('') : `<div class="empty">${data.t.empty}</div>`;
    $('[data-mr-sub]', drawer).textContent = money(cart.total_price);
    /* « Complétez votre costume » */
    let h = '';
    const it = cart.items.find(x => suitOf(x.handle));
    if (it) {
      const opt = it.options_with_values && it.options_with_values[0];
      const size = opt ? opt.value : '';
      const miss = suitOf(it.handle).filter(m => !cart.items.some(x => x.handle === m.h)).map(m => ({ m, v: m.v.find(v => v.s === size && v.a) })).filter(o => o.v);
      if (miss.length) h = `<div class="ups"><h4>${data.t.completeSuit}</h4><p>${data.t.matching.replace('__S__', size)}</p>${miss.map(({ m, v }) => `<div class="r"><a class="th" href="${m.url}"><img src="${m.img}" alt=""></a><div><a href="${m.url}"><b>${m.title}</b></a><span>${money(m.price)}</span></div><button data-mr-up="${v.id}">${data.t.add}</button></div>`).join('')}</div>`;
    }
    $('[data-mr-ups]', drawer).innerHTML = h;
  }
  document.addEventListener('click', async e => {
    if (e.target.closest('[data-mr-cart]')) { e.preventDefault(); await render(); open(); return; }
    if (e.target.closest('[data-mr-close]')) { close(); return; }
    const rm = e.target.closest('[data-mr-rm]');
    if (rm) { await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +rm.dataset.mrRm, quantity: 0 }) }); render(); return; }
    const up = e.target.closest('[data-mr-up]');
    if (up) { add([{ id: +up.dataset.mrUp, quantity: 1 }]); }
  });
  addEventListener('keydown', e => { if (e.key === 'Escape') { close(); nav && nav.classList.remove('on'); } });
  if (location.hash === '#mr-cart') { render().then(open); }
})();

/* fenêtre -10 % : une seule fois (30 jours), après quelques secondes */
(function () {
  const p = document.getElementById('mr-pop'); if (!p) return;
  const KEY = 'mr_pop_seen';
  const seen = () => { try { return +localStorage.getItem(KEY) > Date.now() - 30 * 864e5; } catch (e) { return false; } };
  const mark = () => { try { localStorage.setItem(KEY, Date.now()); } catch (e) {} };
  const open = () => { p.classList.add('on'); mark(); };
  if (p.querySelector('[data-mr-pop-ok]')) { open(); return; }
  if (/[?&]popup/.test(location.search)) { setTimeout(open, 800); }
  else if (seen() || /\/(checkout|cart|account)/.test(location.pathname)) return;
  else
  setTimeout(open, (+p.dataset.delay || 12) * 1000);
  p.addEventListener('click', e => { if (e.target.closest('[data-mr-pop-close]')) p.classList.remove('on'); });
  addEventListener('keydown', e => { if (e.key === 'Escape') p.classList.remove('on'); });
})();
